import { BASIC_LOGIN_APP_LIST } from "./appList";
import COUNTRY_LIST from "./countryList";

class Helper {
    getAppNameById(id) {
        const matchedApp = BASIC_LOGIN_APP_LIST.find((item) => item.id === id);
        return matchedApp ? matchedApp.name : id;
    }

    getGenderByValue(value) {
        if (value) {
            return value.toLowerCase() === "m"
                ? "Male"
                : value.toLowerCase() === "f"
                  ? "Female"
                  : null;
        }
        return null;
    }

    toTitleCase(str) {
        return str
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }

    formatDate(date) {
        return date ? new Date(date).toLocaleString() : "";
    }

    formatArrayToString(array) {
        return Array.isArray(array) && array.length > 0 ? array.join(", ") : "";
    }

    formatCountryList(array) {
        return Array.isArray(array) && array.length > 0
            ? array.map((item) => COUNTRY_LIST[item]).join(", ")
            : "";
    }

    formatAppList(array) {
        return Array.isArray(array) && array.length > 0
            ? array.reduce((acc, item) => {
                  if (item !== "") {
                      const appName = this.getAppNameById(item);
                      if (appName) {
                          if (acc !== "") {
                              acc += ", ";
                          }
                          acc += appName;
                      }
                  }
                  return acc;
              }, "")
            : "";
    }

    formatStatus(status) {
        if (!isNaN(Number(status))) {
            return Number(status) === 1 ? "Enabled" : "Disabled";
        }
        return "";
    }

    accessNestedObject(obj, keyString) {
        const keys = keyString.split(".");
        let currentObj = obj;

        for (const key of keys) {
            if (currentObj && typeof currentObj === "object" && key in currentObj) {
                currentObj = currentObj[key];
            } else {
                // Return undefined if any of the keys don't exist in the nested object
                return undefined;
            }
        }

        return currentObj;
    }

    splitCamelCase = (word) => {
        if (!word) {
            return "";
        }
        const result = word.replace(/([a-z])([A-Z])/g, "$1 $2");
        return result.charAt(0).toUpperCase() + result.slice(1);
    };
}

export default new Helper();
